export function hasPolicyUrl(url?: string): boolean {
  return Boolean(url?.trim());
}

export function isExternalPolicyUrl(url?: string): boolean {
  const trimmed = url?.trim();
  return Boolean(trimmed && /^https?:\/\//i.test(trimmed));
}

export function isInternalPolicyUrl(url?: string): boolean {
  const trimmed = url?.trim();
  return Boolean(trimmed && trimmed.startsWith("/"));
}
